import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { format } from "date-fns";
import { useRotations } from "../../hooks/rotations/useRotations";

const ArchiveRotationDialog = ({
  open,
  onOpenChange,
  rotation,
  onArchived,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rotation: any;
  onArchived: () => void;
}) => {
  const { archiveRotation, loading } = useRotations();

  const onArchive = async () => {
    const archived = await archiveRotation(rotation._id);
    if (!archived) return;
    onArchived();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Archive {format(rotation.date, "MMMM dd, yyyy")} Rotation
          </AlertDialogTitle>
          <AlertDialogDescription>
            Archiving will hide this rotation and all its sessions, classes,
            explorations, enrollments, preferences, and attendance from active
            views. Students and teachers will no longer see it. Pending
            scheduled emails will still send. You can unarchive at any time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading.archiveRotation}>
            {loading.archiveRotation ? "Loading..." : "Cancel"}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onArchive}
            disabled={loading.archiveRotation}
          >
            {loading.archiveRotation ? "Loading..." : "Archive Rotation"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { ArchiveRotationDialog };
